import React, { useEffect, useState } from "react";
import { Button, Form, Modal } from "react-bootstrap";
import { withTranslation } from "react-i18next";
import { toast } from "react-toastify";
import DashGraphConfigService from "../../../core/service/DashGraphConfigService";

const EditGraphSetModal = ({ t, show, graphSet, onClose, onSaved }) => {
  const [setName, setSetName] = useState("");
  const [validated, setValidated] = useState(false);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    if (show) {
      setSetName(graphSet?.name || "");
      setValidated(false);
    }
  }, [show, graphSet]);

  const handleSubmit = (e) => {
    e.preventDefault();
    const form = e.currentTarget;
    setValidated(true);
    if (!form.checkValidity()) return;

    setSaving(true);
    DashGraphConfigService.updateGraphSet(graphSet.id, { name: setName.trim() })
      .then((res) => {
        setSaving(false);
        if (res.status !== 200 && res.status !== 201 && res.status !== 204) return;

        toast.success("Success", { position: toast.POSITION.TOP_RIGHT });
        onClose();
        if (onSaved) onSaved();
      })
      .catch(() => {
        setSaving(false);
      });
  };

  return (
    <Modal show={show} onHide={onClose} centered>
      <Form noValidate validated={validated} onSubmit={handleSubmit}>
        <Modal.Header closeButton>
          <Modal.Title>{t("Edit.label")}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form.Group controlId="editGraphSetName">
            <Form.Label>{t("SetName.label")}</Form.Label>
            <Form.Control
              type="text"
              required
              value={setName}
              onChange={(e) => setSetName(e.target.value)}
            />
          </Form.Group>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="outline-secondary" onClick={onClose}>
            {t("Cancel.label")}
          </Button>
          <Button variant="primary" type="submit" disabled={saving}>
            {t("Save.label")}
          </Button>
        </Modal.Footer>
      </Form>
    </Modal>
  );
};

export default withTranslation()(EditGraphSetModal);
